<section class="ipm-top-sellers" [class.is-page]="isPage" *ngIf="isPage || sellers.length > 0">
    <!-- landing page: title and See All -->
    <div class="ipm-ts-head" *ngIf="!isPage">
        <h2 class="ipm-ts-title">Trending <span>Producers</span></h2>
        <a class="ipm-ts-view-all" routerLink="/top-sellers">See All -></a>
    </div>

    <!-- page: title -->
    <div class="ipm-ts-page-head" *ngIf="isPage">
        <h1 class="ipm-ts-title">Trending <span>Producers</span></h1>
    </div>

    <!-- landing page: one scrolling row -->
    <div class="ipm-ts-row" *ngIf="!isPage" ipmDragScroll>
        <ng-container *ngFor="let seller of sellers | slice : 0 : landingCount; trackBy: trackById">
            <ng-container *ngTemplateOutlet="sellerCard; context: { $implicit: seller }"></ng-container>
        </ng-container>
    </div>

    <!-- page: all the sellers as tiles -->
    <div class="ipm-ts-grid" *ngIf="isPage && sellers.length > 0">
        <ng-container *ngFor="let seller of sellers; trackBy: trackById">
            <ng-container *ngTemplateOutlet="sellerCard; context: { $implicit: seller }"></ng-container>
        </ng-container>
    </div>

    <p class="ipm-ts-empty" *ngIf="isPage && isLoaded && sellers.length === 0">No trending producers to show right now.</p>
</section>

<ng-template #sellerCard let-seller>
    <!-- cover image, name, tier badges, followers / plays and Follow -->
    <div class="ipm-ts-card" (click)="openProfile(seller)">
        <div class="ipm-ts-cover" aria-hidden="true"
            [style.background]="seller.avatar ? null : seller.avatarGradient"
            [style.background-image]="seller.avatar ? 'url(' + seller.avatar + ')' : null"></div>
        <ng-container *ngTemplateOutlet="avatar; context: { $implicit: seller }"></ng-container>
        <div class="ipm-ts-name" [title]="seller.name">
            <span class="ipm-ts-name-text">{{seller.name}}</span>
            <ng-container *ngTemplateOutlet="tierTick; context: { $implicit: seller }"></ng-container>
        </div>
        <div class="ipm-ts-tags" *ngIf="seller.isNew">
            <span class="ipm-ts-badge is-new">New</span>
        </div>
        <div class="ipm-ts-stats" *ngIf="seller.followers !== null || seller.plays !== null">
            <div class="ipm-ts-stat" *ngIf="seller.followers !== null">
                <strong>{{commonService.nFormatter(seller.followers, 1)}}</strong><span>Followers</span>
            </div>
            <div class="ipm-ts-stat" *ngIf="seller.plays !== null">
                <strong>{{commonService.nFormatter(seller.plays, 1)}}</strong><span>Plays</span>
            </div>
        </div>
        <ng-container *ngTemplateOutlet="followButton; context: { $implicit: seller }"></ng-container>
    </div>
</ng-template>

<!-- subscription badge next to the name (same ticks as the beat lists) -->
<ng-template #tierTick let-seller>
    <img class="ipm-ts-tick" *ngIf="seller.pool === 1" src="./assets/imgs/subs_pro_tick_img.png" alt="Pro" title="Pro">
    <img class="ipm-ts-tick" *ngIf="seller.pool === 2" src="./assets/imgs/subs_premium_tick.svg" alt="Premium" title="Premium">
</ng-template>

<ng-template #avatar let-seller>
    <div class="ipm-ts-avatar" [style.background]="seller.avatar ? null : seller.avatarGradient">
        <img *ngIf="seller.avatar; else initialTpl" [src]="seller.avatar" [alt]="seller.name" loading="lazy">
        <ng-template #initialTpl>{{seller.initial}}</ng-template>
    </div>
</ng-template>

<ng-template #followButton let-seller>
    <button type="button" class="ipm-ts-follow" [class.following]="seller.isFollowed" [disabled]="seller.isFollowBusy"
        (click)="toggleFollow(seller, $event)">{{seller.isFollowed ? 'Following' : 'Follow'}}</button>
</ng-template>
